import React, { useEffect, useRef, useState } from 'react';
import { Row, Col, Card, CardHeader, CardBody } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { getCreativesForPublish } from '../../../../slices/publish/thunk';
import { removeCreativeForPublish, selectCreativeForPublish, setPublishLoader, setSelectedCreativesPublish, setSelectedPublishType, setWhereToPublish } from '../../../../slices/publish/reducer';
import { goBack, push } from 'redux-first-history';
import { bytesToKB } from '../../../../slices/helper.js';
import CustomSelect from '../../../../Components/Common/CustomSelect';
import { publishFacebook } from '../../../../slices/publish/facebook/thunk.js';
import { toggleFacebookModal } from '../../../../slices/modals/reducer.js';
import FacebookModal from '../FacebookModal.js';
import SelectPathModal from '../../../Campaigns/Campaign/Social/Facebook/Modals/Feed/SelectPathModal.js';
import FeedConnection from '../../../Campaigns/Campaign/Social/Facebook/Modals/Feed/FeedConnection.js';
import PublishSuccessModal from '../../../Campaigns/Campaign/Social/Facebook/Modals/PublishSuccessModal.js';
import { setCurrentVersion } from '../../../../slices/campaigns/reducer.js';
const $ = require("jquery");
$.DataTable = require("datatables.net-bs5");

function Script() {
  const dispatch = useDispatch();
  const selectVersionState = createSelector(state => state, state => ({
    versions: state.Campaign.versions,
    currentCampaign: state.Campaign.currentCampaign,
    creatives: state.Campaign.creatives,
    title: state.MenuData.title,
    creativesForPublish: state.Publish.creativesForPublish,
    selectedCreativesPublish: state.Publish.selectedCreativesPublish,
    publishTypes: state.Publish.publishTypes,
    isFacebookPropertiesSet: state.Campaign.isFacebookPropertiesSet,
    connectedFeed: state.Campaign.connectedFeed,
    facebookCreativeIds: state.Campaign.facebookCreativeIds,
  }));
  const {
    versions,
    currentCampaign,
    creatives,
    title,
    creativesForPublish,
    selectedCreativesPublish,
    publishTypes,
    isFacebookPropertiesSet,
    connectedFeed,
    facebookCreativeIds,
  } = useSelector(selectVersionState);
  const [versionState, setVersionState] = useState([]);

  useEffect(() => {
    if (Array.isArray(versions) && versions.length > 0) {
      setVersionState([
        { value: 'all', name: 'All Versions' },
        ...versions.map(item => { return { value: item._id, name: item.name } })
      ]);
      dispatch(setCurrentVersion(versions[0]));
    }
  }, [versions]);

  const tableRef = useRef();
  useEffect(() => {
    if (creativesForPublish) {
      try {
        const table = $(tableRef.current).DataTable({
          data: creativesForPublish,
          columns: [
            {
              data: null,
              title: '#',
              orderable: false,
              render: (data, type, row) => {
                if (selectedCreativesPublish.some(sCreative => sCreative._id === row._id)) {
                  return "<input type='checkbox' class='form-check-input' checked />"
                } else {
                  return "<input type='checkbox' class='form-check-input' />"
                }
              }
            },
            {
              data: null,
              title: 'Version',
              render: (data, type, row) => {
                const foundVersion = versions.find(item => item._id === row.versionId);
                if (foundVersion) {
                  return foundVersion.name;
                }
              }
            },
            {
              data: null,
              title: 'Size',
              render: (data, type, row) => {
                return `<p class='m-0'>${row.size}</p>`
              }
            },
            {
              data: null,
              title: 'Publish Status',
              render: (data, type, row) => {
                if (row?.published === true) {
                  return `<span class="badge bg-success-subtle text-primary fs-11 text-uppercase">
                          <i class="ri-checkbox-circle-line align-bottom"></i> Published
                        </span>`
                } else {
                  return `<span class="badge bg-danger text-white fs-11 text-uppercase">
                              <i class="ri-close-circle-line align-bottom"></i> Not Published
                          </span>`
                }
              }
            },
            {
              data: null,
              title: 'Banner Weight',
              render: (data, type, row) => {
                return bytesToKB(row.fileSize);
              }
            },
            // {
            //   data: null,
            //   title: '',
            //   render: (data, type, row) => {
            //     return `<button class='btn btn-info btn-icon btn-sm'>
            //       <i class='ri-eye-fill'></i>
            //     </button>`
            //   }
            // }
          ],
          createdRow: (row, data, dataIndex) => {
            if (selectedCreativesPublish.some(sCreative => sCreative._id === data._id)) {
              $(row).addClass('selected-row');
            }
          },
          responsive: true,
          responsive: {
            details: {
              renderer: $.fn.dataTable.Responsive.renderer.listHiddenNodes()
            }
          },
          columnDefs: [
            { responsivePriority: 1, targets: [1, -2] },
            { responsivePriority: 2, targets: "_all" },
          ],
          language: {},
          destroy: true,
          searching: false,
          paging: false,
          info: false,
        });

        table.on('click', 'tr', function () {
          let tr = $(this).closest("tr");
          if ($(tr).hasClass("child")) {
            tr = $(tr).prev();
          }
          let data = table.row(tr).data();
          if (data) {
            if ($(this).hasClass("selected-row")) {
              $(this).removeClass("selected-row");
              $(this).find(".form-check-input").prop("checked", false);
              dispatch(removeCreativeForPublish(data));
            } else {
              $(this).addClass("selected-row");
              $(this).find(".form-check-input").prop("checked", true);
              dispatch(selectCreativeForPublish(data));
            }
          }
        });

        return function () {
          table.destroy();
        };
      } catch (error) {
        // console.log(error);
      }
    }
  }, [creativesForPublish]);

  function handleVersionChange(version) {
    const foundVersion = versions.find(item => item._id === version.value);
    dispatch(setCurrentVersion(foundVersion));
    dispatch(getCreativesForPublish(version));
  }

  function handleGoBack() {
    dispatch(goBack());
  }

  function showFacebookModal() {
    dispatch(toggleFacebookModal());
  }

  async function facebookPublish() {
    dispatch(setPublishLoader(true));
    await dispatch(publishFacebook());
    dispatch(setPublishLoader(false));
  }

  function checkCreativeIds() {
    // Uzunlukları kontrol et
    if (facebookCreativeIds.length !== selectedCreativesPublish.length) {
      return false;
    }
  
    // Her bir elemanı kontrol et
    for (let i = 0; i < facebookCreativeIds.length; i++) {
      if (facebookCreativeIds[i] !== selectedCreativesPublish[i]._id) {
        return false;
      }
    }
  
    return true;
  }

  return (
    <React.Fragment>
      <Row>
        <Col>
          <Card>
            <div className='w-100 p-3 d-flex align-items-center justify-content-between'>
              <div className='d-flex align-items-center'>
                <button className='btn btn-light btn-icon fw-bold' onClick={handleGoBack}>
                  <i className='ri-arrow-left-line'></i>
                </button>
                <CustomSelect
                  tag='button'
                  className='ms-2 btn btn-light dropdown-toggle'
                  placeholder='Select Versions'
                  options={versionState}
                  onChange={(version) => handleVersionChange(version)}
                  value={(versionState[1]?.name || '')}
                />
              </div>
              <div className='d-flex align-items-center'>
                <div className='d-flex align-items-center me-3'>
                  <svg className='me-1' style={{ width: '25px' }} xmlns="http://www.w3.org/2000/svg" width="38.114" height="36.3" viewBox="0 0 38.114 36.3">
                    <defs>
                      <clipPath id="clip-path">
                        <rect id="Rectangle_125" data-name="Rectangle 125" width="38.114" height="36.3" transform="translate(0 0)" fill="none" />
                      </clipPath>
                    </defs>
                    <g id="Group_357" data-name="Group 357" transform="translate(0 0)">
                      <g id="Group_356" data-name="Group 356" clip-path="url(#clip-path)">
                        <path id="Path_104" data-name="Path 104" d="M0,32.7V28.1H14.85a20.476,20.476,0,0,0,.2,2.325A8.779,8.779,0,0,0,15.8,32.7Zm0-9.4V18.75H19.35a9.443,9.443,0,0,0-1.975,2.1A12.553,12.553,0,0,0,16.05,23.3ZM0,9.4H32V14H0ZM0,0H32V4.6H0Z" fill="#94f956" />
                        <path id="Path_105" data-name="Path 105" d="M21,36.3a1.963,1.963,0,0,1-1.95-1.95,1.962,1.962,0,0,1,.575-1.4A1.838,1.838,0,0,1,21,32.35h5.7L22.1,29.1a1.822,1.822,0,0,1-.85-1.225,2.107,2.107,0,0,1,.3-1.525,1.712,1.712,0,0,1,1.2-.8,2.3,2.3,0,0,1,1.55.25l4.65,3.25-2-5.3a2.49,2.49,0,0,1,.125-1.6,1.741,1.741,0,0,1,1.175-1,1.987,1.987,0,0,1,1.6.075,1.709,1.709,0,0,1,1,1.125L32.7,27.7l1.55-5.45a1.882,1.882,0,0,1,.85-1.2,1.918,1.918,0,0,1,1.5-.2,2.192,2.192,0,0,1,1.225.9,1.763,1.763,0,0,1,.225,1.45l-3.1,11.6a2.5,2.5,0,0,1-.725,1.1A1.836,1.836,0,0,1,33,36.3Z" fill="#030541" />
                      </g>
                    </g>
                  </svg>
                  <p className='m-0'>Exporting as Script</p>
                </div>
                {selectedCreativesPublish.length > 0 ?
                  <button className={'btn btn-info btn-facebook' + (isFacebookPropertiesSet ? ' btn-facebook' : ' btn-soft-facebook')} onClick={showFacebookModal}>
                    <i className='ri-facebook-fill'></i>
                  </button>
                  : null}
                {facebookCreativeIds.length > 0 && selectedCreativesPublish.length > 0 && checkCreativeIds() && isFacebookPropertiesSet ?
                  <button className='btn btn-success ms-3' onClick={facebookPublish}>Publish</button>
                  : null}
              </div>
            </div>
          </Card>
        </Col>
      </Row>
      {creativesForPublish ?
        <Row>
          <Col xxl={12} xl={12} lg={12} md={12} sm={12}>
            <Card>
              {/* <CardHeader>
                Select which banners you want to publish
              </CardHeader> */}
              <CardBody>
                <div className='table-responsive table-card mt-0 pt-2'>
                  <table
                    className="align-middle table-nowrap mb-0 table"
                    style={{ width: "100%" }}
                    ref={tableRef}
                  >
                    <thead className="table-light"></thead>
                    <tbody></tbody>
                  </table>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
        : null}
      <FacebookModal />
      <FeedConnection />
      <SelectPathModal />
      <PublishSuccessModal />
    </React.Fragment>
  )
}

export default Script
